/* 🤖 this file was generated by svg-to-ts*/
export const iconPhoto = {
  name: 'photo',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" fill-opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M21 5v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zM11 16.51l-2.1-2.53a.493.493 0 00-.78.02l-2.49 3.2c-.26.33-.03.81.39.81h11.99a.5.5 0 00.4-.8l-3.51-4.68c-.2-.27-.6-.27-.8-.01L11 16.51z"/></svg>`,
}
